// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_staffing_readiness.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { CaptureSolutionGap } from "./capture_solution_alternatives_pb";
/**
 * SAD-501: early role-level plans. These never allocate employees, resolve
 * source gaps, change LOE, or advance an agreement's lifecycle.
 *
 * @generated from message mono.projectdata.v1.CaptureStaffingReadinessRevision
 */ export class CaptureStaffingReadinessRevision extends Message {
    static fromBinary(bytes, options) {
        return new CaptureStaffingReadinessRevision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureStaffingReadinessRevision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureStaffingReadinessRevision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureStaffingReadinessRevision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string gap_id = 4;
   */ _define_property(this, "gapId", ""), /**
   * @generated from field: int64 revision = 5;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * @generated from field: string request_id = 6;
   */ _define_property(this, "requestId", ""), /**
   * hiring | teammate
   *
   * @generated from field: string kind = 7;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string candidate_id = 8;
   */ _define_property(this, "candidateId", ""), /**
   * Canonical delivery.company_profiles ID, resolved from candidate_id.
   *
   * @generated from field: string company_profile_id = 9;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string source_candidate_event_id = 10;
   */ _define_property(this, "sourceCandidateEventId", ""), /**
   * Optional immutable workshare entry; its percentage is whole effort.
   *
   * @generated from field: string workshare_id = 11;
   */ _define_property(this, "workshareId", ""), /**
   * Position, not a person or employee allocation.
   *
   * @generated from field: string role = 12;
   */ _define_property(this, "role", ""), /**
   * Hiring: planned | in_progress | ready | blocked | cancelled.
   * Teammate: proposed | unconfirmed. Never a contractual commitment.
   *
   * @generated from field: string status = 13;
   */ _define_property(this, "status", ""), /**
   * internal | recruiting | partner | unknown
   *
   * @generated from field: string likely_source = 14;
   */ _define_property(this, "likelySource", ""), /**
   * YYYY-MM-DD or empty.
   *
   * @generated from field: string target_date = 15;
   */ _define_property(this, "targetDate", ""), /**
   * Availability uncertainty and accountable follow-ups; no payroll data.
   *
   * @generated from field: string notes = 16;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string actor_user_id = 17;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 18;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureStaffingReadinessRevision, "runtime", proto3);
_define_property(CaptureStaffingReadinessRevision, "typeName", "mono.projectdata.v1.CaptureStaffingReadinessRevision");
_define_property(CaptureStaffingReadinessRevision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "gap_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_candidate_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "workshare_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "likely_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "target_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureStaffingReadiness
 */ export class CaptureStaffingReadiness extends Message {
    static fromBinary(bytes, options) {
        return new CaptureStaffingReadiness().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureStaffingReadiness().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureStaffingReadiness().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureStaffingReadiness, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionGap gap = 1;
   */ _define_property(this, "gap", void 0), /**
   * @generated from field: mono.projectdata.v1.CaptureStaffingReadinessRevision current = 2;
   */ _define_property(this, "current", void 0), /**
   * Newest first, immutable source candidate event and workshare lineage.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureStaffingReadinessRevision history = 3;
   */ _define_property(this, "history", []), /**
   * No viable action recorded; never inferred from an effort percentage.
   *
   * @generated from field: bool uncovered = 4;
   */ _define_property(this, "uncovered", false), /**
   * Canonical candidate event or referenced candidate+area workshare changed.
   *
   * @generated from field: bool needs_review = 5;
   */ _define_property(this, "needsReview", false), /**
   * @generated from field: string current_candidate_status = 6;
   */ _define_property(this, "currentCandidateStatus", ""), /**
   * A working assumption even when hiring readiness is ready.
   *
   * @generated from field: bool provisional = 7;
   */ _define_property(this, "provisional", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureStaffingReadiness, "runtime", proto3);
_define_property(CaptureStaffingReadiness, "typeName", "mono.projectdata.v1.CaptureStaffingReadiness");
_define_property(CaptureStaffingReadiness, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gap",
            kind: "message",
            T: CaptureSolutionGap
        },
        {
            no: 2,
            name: "current",
            kind: "message",
            T: CaptureStaffingReadinessRevision
        },
        {
            no: 3,
            name: "history",
            kind: "message",
            T: CaptureStaffingReadinessRevision,
            repeated: true
        },
        {
            no: 4,
            name: "uncovered",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "needs_review",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "current_candidate_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "provisional",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureStaffingReadinessRequest
 */ export class GetCaptureStaffingReadinessRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureStaffingReadinessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureStaffingReadinessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureStaffingReadinessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureStaffingReadinessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureStaffingReadinessRequest, "runtime", proto3);
_define_property(GetCaptureStaffingReadinessRequest, "typeName", "mono.projectdata.v1.GetCaptureStaffingReadinessRequest");
_define_property(GetCaptureStaffingReadinessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureStaffingReadinessResponse
 */ export class GetCaptureStaffingReadinessResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureStaffingReadinessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureStaffingReadinessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureStaffingReadinessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureStaffingReadinessResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Includes staffing gaps without any action. Agreement status remains on
   * GetCaptureTeamingAgreements; never infer it from a readiness label.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureStaffingReadiness gaps = 1;
   */ _define_property(this, "gaps", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureStaffingReadinessResponse, "runtime", proto3);
_define_property(GetCaptureStaffingReadinessResponse, "typeName", "mono.projectdata.v1.GetCaptureStaffingReadinessResponse");
_define_property(GetCaptureStaffingReadinessResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "gaps",
            kind: "message",
            T: CaptureStaffingReadiness,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureStaffingReadinessRequest
 */ export class SaveCaptureStaffingReadinessRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureStaffingReadinessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureStaffingReadinessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureStaffingReadinessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureStaffingReadinessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * The ProjectData facade derives tenant/capture from the authorized record.
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * Per canonical gap, initially zero. A stale edit is Aborted.
   *
   * @generated from field: int64 expected_revision = 4;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: string gap_id = 5;
   */ _define_property(this, "gapId", ""), /**
   * @generated from field: string kind = 6;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string candidate_id = 7;
   */ _define_property(this, "candidateId", ""), /**
   * @generated from field: string workshare_id = 8;
   */ _define_property(this, "workshareId", ""), /**
   * @generated from field: string role = 9;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string status = 10;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string likely_source = 11;
   */ _define_property(this, "likelySource", ""), /**
   * @generated from field: string target_date = 12;
   */ _define_property(this, "targetDate", ""), /**
   * @generated from field: string notes = 13;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureStaffingReadinessRequest, "runtime", proto3);
_define_property(SaveCaptureStaffingReadinessRequest, "typeName", "mono.projectdata.v1.SaveCaptureStaffingReadinessRequest");
_define_property(SaveCaptureStaffingReadinessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "gap_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "workshare_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "likely_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "target_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureStaffingReadinessResponse
 */ export class SaveCaptureStaffingReadinessResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureStaffingReadinessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureStaffingReadinessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureStaffingReadinessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureStaffingReadinessResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureStaffingReadinessRevision revision = 1;
   */ _define_property(this, "revision", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureStaffingReadinessResponse, "runtime", proto3);
_define_property(SaveCaptureStaffingReadinessResponse, "typeName", "mono.projectdata.v1.SaveCaptureStaffingReadinessResponse");
_define_property(SaveCaptureStaffingReadinessResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "revision",
            kind: "message",
            T: CaptureStaffingReadinessRevision
        }
    ]));
